@for (product of model.products; track product.productName) {
  <div
    class="issues-product-card bolt-row"
    >
    <div class="bolt-col">
      <div class="top-row">
        <div class="text">
          <bolt-icon
            name="exclamation-circle-filled"
            color="cherryRed"
            size="sm"
          ></bolt-icon>
          <div class="title">{{ product.productName }} UW issues</div>
          <div class="count">({{ product.issues.length }} issues)</div>
        </div>
        <div class="spacer"></div>
        <div class="buttons">
          @if (!hasDisabled(product)) {
            <bolt-button
              type="solid"
              size="sm"
              (click)="onRequestUwApproval(product.productType, user)"
              [disabled]="product.disableApproval || null"
              >Request UW approval</bolt-button
              >
            }
            <bolt-button
              type="outline"
              size="sm"
              (click)="onRemoveProduct(product.productType)"
              >Remove {{ product.productName }}</bolt-button
              >
            </div>
          </div>
          @for (message of product.issues; track message) {
            <div class="message">
              {{ message }}
            </div>
          }
        </div>
      </div>
    }
